import React from 'react';
// import companyLogo from '../../Assets/Images/Appointlogo.png'
import companyLogo from '../../Assets/Images/Appointlogo.png'

const AppointmentTemplate = ({ tenantName, companyAddress, companyContact, currentdate,
    employeeName, offerDate, designation, joiningDate, restrictionPeriod, ManagerName, salaryComponents, totalCTC
}) => {

    return `

        <div
            style="
                font-family: "Arial, sans-serif";
                font-size: "14px";
                color: "#000";
                line-height: 1.6
            ">


            <div
                style="
                    display: "flex";
                    align-items: "center";
                    margin-bottom: "20px"
                "
            >

                <img src=${companyLogo} alt="Company Logo"
                    style=
                        "height: 85px;
                        border:none;
                        background-color:white;
                        margin-right: 10px;
                        width:100%"
                    
                />
              
            </div>

            <hr />


           
             <p style="text-align:right;">
  <strong>Date:</strong> ${currentdate}
</p>


            <p>
                To,<br />
                ${employeeName}
            </p>

         <h3 style="text-align:center; margin-top:40px;">

                LETTER OF APPOINTMENT</h3>


            <p>Dear <strong>${employeeName}
            </strong>,</p>

            <p>
                With reference to our discussion and letter of offer dated <strong>${offerDate}</strong>, we are pleased to appoint you as <strong>${designation?.designation || designation?.name || ""}</strong>
                w.e.f. <strong>${joiningDate
            ? new Date(joiningDate).toLocaleDateString()
            : "TBD"}

                </strong> subject to the following terms and conditions. The remuneration details are enclosed herewith as <strong>Annexure – A</strong>.
            </p>

            <h3>TERMS & CONDITIONS</h3> 

            <ol>
                <li>
                    <strong>Probation Period</strong>
                    <ol type="a">
                        <li>The probation period shall be three (3) months from the date of joining.</li>
                        <li>Either party may terminate the employment during probation by giving one month’s notice in writing.</li>
                    </ol>
                </li>

                <li>
                    In case you leave the company before completion of one year of service, you shall refund all joining expenses reimbursed to you.
                </li>

                <li>
                    After confirmation, either party may terminate employment by giving three months’ notice or salary in lieu thereof.
                </li>

                <li>
                    Your services may be terminated without notice in case of violation of company policies or loss of confidence.
                </li>

                <li>
                    <strong>Appraisal Policy</strong>
                    <ol type="a">
                        <li>No appraisal shall be applicable during the first two years of employment.</li>
                        <li>Future appraisals shall depend on company policy and performance.</li>
                    </ol>
                </li>

                <li>
                    You shall be entitled to leave benefits as per company leave policy. Leaves cannot be carried forward.
                </li>

                <li>
                    You shall report to the undersigned or any officer designated by the management.
                </li>

                <li>
                    You agree to cooperate and contribute towards the company’s operational efficiency.
                </li>

                <li>
                    You may be assigned additional duties or responsibilities as required by the company.
                </li>

                <li>
                    You may be transferred to any department, unit, or location of the company in India or abroad.
                </li>

                <li>
                    You shall comply with all company policies, service rules, and code of conduct.
                </li>

                <li>
                    You shall not engage in any other business or employment without prior written permission.
                </li>

                <li>
                    Confidentiality of company information must be maintained during and after employment.
                </li>

                <li>
                    Any invention or intellectual property developed during employment shall be the property of the company.
                </li>

                <li>
                    You shall not accept employment with company clients during employment and for  ${restrictionPeriod?.restrictionPeriod} months
                    months after separation.
                </li>

                <li>
                    Employment is subject to medical fitness certified by a company-approved medical practitioner.
                </li>

                <li>
                    You shall not work with any competitor for a period of three years after separation.
                </li>

                <li>
                    The retirement age shall be 58 years.
                </li>

                <li style="margin-top:30px;">
                    <strong style="margin-top:40px;" >Notice Period</strong>
                    <ol type="a">
                        <li>The notice period shall be 60 days.</li>
                        <li>Early release may be granted at management discretion.</li>
                    </ol>
                </li>


            </ol>

      <h3> SIGNATURE</h3> 

            <p style="marginTop: "40px" >Yours faithfully,</p>

            <p>
                For <strong>${tenantName}</strong><br />
                ${ManagerName}
                <br />
                Authorised Signatory
            </p>

            <hr />

            <h3> ACCEPTANCE</h3>

            <p>
                I have carefully read and fully understood the terms and conditions of my employment and hereby accept the same.
            </p>

            <p>
                <strong>Name:</strong> ${employeeName}<br />
                <strong>Signature:</strong> ____________________<br />
                <strong>Date:</strong> ____________________<br />
            </p>

            

            <h3 style="
                textAlign: 'center';
                marginTop: '40px'
            ">ANNEXURE – A</h3>

            <p>
                <strong>Name:</strong> ${employeeName}<br />
                <strong>Designation:</strong>${designation}
            </p>




        <table width = "100%" cellpadding = "8" cellspacing = "0"
    style = "
    border-collapse: collapse;
    font-size: 13px;
    margin-top: 10px;
    ">

        <thead>
        <tr style="background-color:#f2f2f2;">
            <th style="border:1px solid #000; text-align:center;">S.No</th>
            <th style="border:1px solid #000; text-align:left;">Salary Component</th>
            <th style="border:1px solid #000; text-align:right;">Per Month (₹)</th>
            <th style="border:1px solid #000; text-align:right;">Per Annum (₹)</th>
        </tr>
  </thead >

    <tbody>
        ${salaryComponents.map((row, i) => `
      <tr>
        <td style="border:1px solid #000; text-align:center;">${i + 1}</td>
        <td style="border:1px solid #000;">${row.name}</td>
        <td style="border:1px solid #000; text-align:right;">
          ₹ ${Number(row.monthly).toLocaleString()}
        </td>
        <td style="border:1px solid #000; text-align:right;">
          ₹ ${Number(row.annual).toLocaleString()}
        </td>
      </tr>
    `).join("")}

        <tr style="font-weight:bold; background-color:#fafafa;">
            <td colspan="3" style="border:1px solid #000; text-align:right;">
                Total CTC
            </td>
            <td style="border:1px solid #000; text-align:right;">
                ₹ ${Number(totalCTC).toLocaleString()}
            </td>
        </tr>
    </tbody>
</table >





    <p style="marginTop: '10px'; fontSize: '12px' ">* As per company CTC policy.</p>

        </div >
    `
}

export default AppointmentTemplate